export const PUBLISHED_BOARD_VIEWERS_LOAD = 'PUBLISHED_BOARD_VIEWERS_LOAD';
export const RESET_PUBLISHED_BOARD_VIEWERS = 'RESET_PUBLISHED_BOARD_VIEWERS';
